import React, { useMemo } from 'react'

import CarDetails from 'components/organisms/CarDetails'

import CarDetailsPageTitle from '../CarDetails/CarDetailsPageTitle'

export default function SessionsCarDetails({ cars, vin, setShowDetails }) {
  const car = useMemo(
    () =>
      vin && cars.find((car) => car.vin.toLowerCase() === vin.toLowerCase()),
    [cars, vin]
  )

  return (
    <div className="content-container" data-testid="car-details">
      <>
        <CarDetailsPageTitle
          setShowDetails={setShowDetails}
          cars={cars}
          vin={vin}
        />
        {car && <CarDetails car={car} price={car.prices?.[1]} fee={car.fee} />}
      </>
    </div>
  )
}
